import React, { Component, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import moment from "moment";
import jwt_decode from "jwt-decode";

import "../../node_modules/font-awesome/scss/font-awesome.scss";

import Loader from "./layout/Loader";
import Aux from "../hoc/_Aux";
import ScrollToTop from "./layout/ScrollToTop";
import routes from "../route";
import { AuthToken } from "../lib/MyHttp";

const AdminLayout = Loadable({
    loader: () => import("./layout/AdminLayout"),
    loading: Loader
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = { show: false };
    }

    /**
     * 토큰 갱신
     * @param {*} grant_type
     */
    refreshToken = grant_type => {
        AuthToken(
            this,
            grant_type,
            res => {
                console.log("res", res);
            },
            res => {
                localStorage.setItem("access_token", "");
                localStorage.setItem("refresh_token", "");
                window.location.href = "/";
            }
        );
    };

    render() {
        let auth = localStorage.getItem("access_token");
        let role = localStorage.getItem("role");

        if (auth === "" || role === undefined || role === "") {
            auth = null;
        }

        let menu = routes.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} exact={route.exact} name={route.name} render={props => <route.component {...props} />} /> : null;
        });

        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader />}>
                        <Switch>
                            {/* {menu} */}
                            {/* <Route path="/" component={AdminLayout} /> */}
                            {auth === null || role === null ? menu : ""}
                            {auth === null || role === null ? <Redirect from="/" to="/auth/signin" /> : <Route path="/" component={AdminLayout} />}
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;
